export default [
    {
        path: '/bin-fill/fill-bin-into-bin',
        name: 'bin_fill_fill_bin_into_bin',
        component: () => import('@src/bin-fill/fill-bin-into-bin.vue'),
        meta: {
            title: 'Lagerfach umschütten',
            role: 'ROLE_BIN_FILL',
        },
    },
    {
        path: '/bin-fill/bin-transfer-queues',
        name: 'bin_fill_bin_transfer_queues',
        component: () => import('@src/bin-fill/bin-transfer-queues.vue'),
        meta: {
            title: 'Ausstehende Umlagerungen (Lagerfach umschütten)',
            role: 'ROLE_BIN_FILL',
        },
    },
];
